// extracted by mini-css-extract-plugin
export default {"root_image_inner":"programmeUpdationForm_root_image_inner__bQnSZ","FormTabs_root":"programmeUpdationForm_FormTabs_root__FTQNj"};